module.exports = __webpack_public_path__ + "img/soc.667dbb5a.svg";